import React, { Component } from 'react';
import MultiSelectDropdown from "../../components/dropdown/MultiSelectDropdown.js";
import ValidationText from "../../utils/validation/ValidationText.js";
import moment from 'moment';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faTrash, faXmark, faCheck, faSpinner } from "@fortawesome/free-solid-svg-icons";
import ModalBasic from "../../pages/component/ModalBasic.js";
import CommonServices from '../../services/axioServices/apiServices/CommonServices.js';
import { isValidForm } from '../../utils/validation/CommonValidator.js';
import { CommonSuccessMessages, CommonValidationMessages } from '../../utils/Messages.js';
import SwalServices from '../../services/swalServices/SwalServices.js';
import DespatchServices from '../../services/axioServices/apiServices/DespatchServices.js';
import { encryptionAPI } from '../../utils/Encryption.js';
import { APIURL } from '../../utils/AppSetting.js';
import { GenerateGSTInvoiceForFinishGoodsById } from '../../services/axioServices/ApiEndPoints.js';

class SalesGoodsReturnEntry extends Component {
    constructor(props) {
        super(props);
        this.commonServices = new CommonServices();
        this.SwalServices = new SwalServices();
        this.despatchServices = new DespatchServices();
        this.state = {
            isEditing: false,
            isLoading: false,
            tableStatus: "",
            validationTextForStock: "",
            isGridView: true,
            setItemDetailsModel: false,
            index: null,
            transportCourierList: [],
            productionStockList: [],
            partyDropdownList: [],
            companyItemList: [],
            hsnCodeListForTable: [],
            hsnCodeList: [],
            itemListing: [],
            salesGoodsReturnList: [],
            filterDetails: {
                partyName: "",
                arrangedBy: "",
            },
            salesReturnDetails: {
                salesGoodsReturnId: "",
                serialNo: "",
                returnDate: "",
                deliveryChallanNo: "",
                dcDate: "",
                transportId: "",
                transportName: "",
                partyId: "",
                lRNo: "",
                lRDate: "",
                subTotal: "",
                sgst: "",
                cgst: "",
                other: "",
                round: "",
                grandTotal: "",
            },
            itemDetails: {
                itemId: "",
                packing: "",
                batchNo: "",
                mfgDate: "",
                expDate: "",
                stockUpgrade: "",
                invoiceNo: "",
                invoiceDate: "",
                returnType: "",
                mrp: "0",
                qty: "0",
                free: "0",
                rate: "",
                amount: "0",
                other: "0",
                taxableAmount: "0",
                hsnCodeId: "",
                hsnCodeName: "",
                sgstRate: "0",
                cgstRate: "0",
                igstRate: "0",
                ugstRate: "0",
                batchClearingEntryId: null,
                stockId: ''
            },
            arrangedByList: [
                { arrangedBy: "Party Name", value: "partyName" },
                { arrangedBy: "Ser. No", value: "serialNo" },
                { arrangedBy: "Amount", value: "grandTotal" },

            ],
            stockUpgradeList: [
                { stockUpgrade: "Yes", value: "yes" },
                { stockUpgrade: "No", value: "no" },

            ],
            returnTypeList: [
                { returnType: "Non-Moving", value: "non-moving" },
                { returnType: "Expiry", value: "expiry" },
                { returnType: "Breackage", value: "breackage" },
                { returnType: "Others", value: "others" },
            ],
            validationRules: {
                itemId: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "item name"
                        ),
                    },
                ],
                qty: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "quantity"
                        ),
                    },
                    {
                        type: "graterThenZero",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "rate"
                        ),
                    },
                ],
                rate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "rate"
                        ),
                    },
                    {
                        type: "graterThenZero",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "rate"
                        ),
                    },
                ],
                returnType: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "return type"
                        ),
                    },
                ],
                stockUpgrade: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "stock upgrade"
                        ),
                    },
                ],
                hsnCodeId: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "hSN Code"
                        ),
                    },
                ],

            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRulesForPartyDetails: {
                partyId: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "party name"
                        ),
                    },
                ],
                transportName: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "transport name"
                        ),
                    },
                ],
                transportId: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "transport name"
                        ),
                    },
                ],
            },
            validStateForPartyDetails: {
                isValid: true,
                error: {},
            },
        };
    }
    componentDidMount() {
        this.getAllSalesGoodsReturnEntry()
    }

    getAllSalesGoodsReturnEntry = () => {
        this.setState({ tableStatus: "Loading..." })
        let request = this.state.filterDetails
        this.despatchServices.getAllSalesGoodsReturnEntry(request).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                if (response.responseData.length === 0) {
                    this.setState({ tableStatus: "No Record Found" })
                } else {
                    this.setState({ tableStatus: "" })
                }
                this.setState({ salesGoodsReturnList: response.responseData }, () => {
                    this.getAllPartyDropdown()
                })
            } else {
                this.setState({ tableStatus: "" })
                this.getAllPartyDropdown();
                this.SwalServices.Error(response.Message);
            }
        });
    };

    getAllPartyDropdown = () => {
        this.commonServices.getAllPartyDropdown().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData;
                let dropdownItems = res.map((item) => ({
                    label: item.partyName,
                    value: item._id,
                    email: item.email,
                    transporterName: item.transporterName
                }));
                this.setState({ partyDropdownList: dropdownItems }, () => {
                    this.getAllTransportCourier();
                });
            } else {
                this.getAllTransportCourier();
                this.SwalServices.Error(
                    response.Message
                );
            }
        });
    };
    getAllTransportCourier = () => {
        this.commonServices.getAllTransportCourier("").then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let dropdownItems = response.responseData.map((item) => ({
                    label: item.transportName,
                    value: item._id,
                }));
                this.setState({ transportCourierList: dropdownItems }
                    , () => {
                        this.getAllItem()
                    }
                );
            } else {
                this.getAllItem()
                this.SwalServices.Error(response.Message);
            }
        });
    };
    getAllItem = () => {
        this.commonServices.getAllItem().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData;
                let dropdownItems = res.map((item) => ({
                    label: item.ItemName,
                    value: item._id,
                    packing: item.Packing,
                }));
                this.setState({ companyItemList: dropdownItems }, () => {
                    this.getAllHSNCode()
                });
            } else {
                this.getAllHSNCode()
                this.SwalServices.Error(
                    response.Message
                );
            }
        });
    };

    getAllHSNCode = () => {
        this.commonServices.getAllHSNCode().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData;
                let dropdownItems = res.map((item) => ({
                    label: item.HSNCode,
                    value: item._id,
                    sgstRate: item.SGST,
                    cgstRate: item.CGST,
                    igstRate: item.IGST,
                    utgstRate: item.UTGST
                }));
                this.setState({ hsnCodeList: dropdownItems });
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    };
    closeGridView = () => {
        this.setState({ isGridView: false });
    };

    openGridView = () => {
        this.resetForm();
        this.setState({ isGridView: true, isEditing: false }, () => {
            this.getAllSalesGoodsReturnEntry()
        });
    };

    openPopUpForAddingItem = () => {
        this.resetItemDetails()
        this.setState({ setItemDetailsModel: true })
    };

    closePopUp = () => {
        this.setState({ setItemDetailsModel: false })
    }

    resetForm = () => {
        this.resetFilterDetails()
        this.resetSalesReturnDetails()
        this.resetItemDetails()
    }

    resetFilterDetails = () => {
        let Fdetails = this.state.filterDetails
        Fdetails.partyName = ""
        Fdetails.arrangedBy = ""
        this.setState({
            filterDetails: Fdetails, noItemFound: ""
        });
    }

    resetItemDetails = () => {
        let validstate = this.state.validState
        validstate.isValid = true
        validstate.error = {}
        let Idetails = this.state.itemDetails
        Idetails.itemId = ""
        Idetails.packing = ""
        Idetails.batchNo = ""
        Idetails.mfgDate = ""
        Idetails.expDate = ""
        Idetails.stockUpgrade = ""
        Idetails.invoiceNo = ""
        Idetails.invoiceDate = ""
        Idetails.returnType = ""
        Idetails.mrp = "0"
        Idetails.qty = "0"
        Idetails.free = "0"
        Idetails.rate = "0"
        Idetails.amount = "0"
        Idetails.other = "0"
        Idetails.taxableAmount = "0"
        Idetails.hsnCodeId = ""
        Idetails.hsnCodeName = ""
        Idetails.sgstRate = "0"
        Idetails.cgstRate = "0"
        Idetails.igstRate = "0"
        Idetails.ugstRate = "0"
        this.setState({
            itemDetails: Idetails,
            validstate: validstate,
            validationTextForStock: "",
            productionStockList: []

        });

    };

    resetSalesReturnDetails = () => {
        let validstate = this.state.validStateForPartyDetails
        validstate.isValid = true
        validstate.error = {}
        let Sdetails = this.state.salesReturnDetails
        Sdetails.serialNo = ""
        Sdetails.returnDate = ""
        Sdetails.deliveryChallanNo = ""
        Sdetails.transportId = ""
        Sdetails.transportName = ""
        Sdetails.deliveryChallanNo = ""
        Sdetails.dcDate = ""
        Sdetails.partyId = ""
        Sdetails.lRNo = ""
        Sdetails.lRDate = ""
        Sdetails.subTotal = ""
        Sdetails.sgst = ""
        Sdetails.cgst = ""
        Sdetails.other = ""
        Sdetails.round = ""
        Sdetails.grandTotal = ""
        this.setState({
            salesReturnDetails: Sdetails,
            validStateForPartyDetails: validstate,
            itemListing: [],
            hsnCodeListForTable: [],
        });

    }

    handleDropDownChange = (event, name, section) => {
        const select = event.target.value;
        if (section === "filterDetails") {
            let details = this.state.filterDetails;
            details[name] = select;
            this.setState({ filterDetails: details }, () => {
                this.getAllSalesGoodsReturnEntry()
            });
        }
        else if (section === "itemDetails") {
            let details = this.state.itemDetails;
            details[name] = select;
            this.setState({ itemDetails: details });
        }
    };

    handleChange = (event, name, section) => {
        let value = event.target.value;
        if (section === "filterDetails") {
            let details = this.state.filterDetails;
            details[name] = value.toUpperCase();
            this.setState({ filterDetails: details },
                () => {
                    this.getAllSalesGoodsReturnEntry()
                }
            );
        }
        else if (section === "salesReturnDetails") {
            let details = this.state.salesReturnDetails;
            details[name] = value.toUpperCase();
            if (name === 'other' || name === 'round') {
                this.calculateGrandTotal()
            }
            this.setState({ salesReturnDetails: details });
        }
    };

    handleChangeForItemTable = (event, fieldName) => {
        let value = event.target.value
        let details = this.state.itemDetails;
        details[fieldName] = value;
        this.setState({ itemDetails: details }, () => {
            if (fieldName === 'rate' || fieldName === 'qty' || fieldName === 'free' || fieldName === 'other') {
                this.calculateItemCost()
            }
        });
    };

    calculateItemCost = () => {
        let details = this.state.itemDetails
        details.amount = Number(details.qty) * Number(details.rate)
        details.taxableAmount = ((Number(details.qty) + Number(details.free)) * Number(details.rate)) + Number(details.other)
        this.setState({ itemDetails: details })
    }

    setFilterParameters = (selected, drpIdentity, section) => {
        let details = this.state.salesReturnDetails;
        details[drpIdentity] = selected.value;
        if (drpIdentity === 'partyId') {
            details.transportName = selected.transporterName
            details.transportId = selected.transporterName ?
                this.state.transportCourierList.find(tran => tran.label === selected.transporterName) ? this.state.transportCourierList.find(tran => tran.label === selected.transporterName).value : ''
                : ''
        }
        if (drpIdentity === 'transportName') {
            details.transportName = selected.label
            details.transportId = selected.value
        }
        this.setState({ salesReturnDetails: details });
    };

    setFilterParametersForItemTable = (selected, fieldName) => {
        let details = this.state.itemDetails;
        details[fieldName] = selected.value;
        if (fieldName === 'itemId') {
            details.packing = selected.packing
            details.itemName = selected.label

            this.getProductionStockByProductId(selected.value)
        }
        if (fieldName === 'hsnCodeId') {
            details.hsnCodeName = selected.label
            details.sgstRate = selected.sgstRate
            details.cgstRate = selected.cgstRate
            details.igstRate = selected.igstRate
            details.ugstRate = selected.utgstRate
        }
        this.setState({ itemDetails: details });
        // }
    };

    getAllBatchesForItemByItemId = (id) => {
        this.despatchServices.getAllBatchesForItemByItemId(id).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let resList = response.responseData
                let itemListing = this.state.itemListing
                resList = resList.filter(resItem => resItem.quantity > 0);
                resList = resList.map(resItem => {
                    let matches = itemListing.filter(item => (!item._id) && (item.batchClearingEntryId === resItem.batchClearingEntryId) && (item.batchNo === (resItem.productDetialsId ? resItem.productDetialsId.batchNo : resItem.batchNo)));
                    if (matches.length > 0) {
                        let totalQty = matches.reduce((sum, item) => sum + Number(item.qty), 0);
                        let totalFreeQty = matches.reduce((sum, item) => sum + Number(item.free), 0);
                        let totalReduceQty = totalQty + totalFreeQty
                        resItem.quantity -= totalReduceQty;
                    }
                    return resItem;
                });

                if (resList.length > 0) {
                    this.setState({ productionStockList: resList, validationTextForStock: '' })
                } else {
                    this.setState({ productionStockList: [], validationTextForStock: `Sorry, No Batch available for ${this.state.itemDetails.itemName ? this.state.itemDetails.itemName : 'this product'}.` })
                }
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    }

    getProductionStockByProductId = (id) => {
        this.despatchServices.getProductionStockByProductId(id).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let resList = response.responseData
                let itemListing = this.state.itemListing

                // resList = resList.map(resItem => {
                //     let matches = itemListing.filter(item => (!item._id) && (item.batchClearingEntryId === resItem.batchClearingEntryId) && (item.batchNo === (resItem.productDetialsId ? resItem.productDetialsId.batchNo : resItem.batchNo)));
                //     if (matches.length > 0) {
                //         // let totalQty = matches.reduce((sum, item) => sum + Number(item.qty), 0);
                //         // let totalFreeQty = matches.reduce((sum, item) => sum + Number(item.free), 0);
                //         let totalReduceQty = 0
                //         resItem.quantity -= totalReduceQty;
                //     }
                //     return resItem;
                // });

                if (this.state.isEditing === true) {
                    let item = response.responseData.find(x => x.batchClearingEntryId === this.state.itemDetails.batchClearingEntryId)
                    if (item) {
                        let details = this.state.itemDetails
                        details.stockTotalqty = item.quantity + details.free + details.qty
                        details.stockId = item._id
                        this.setState({ itemDetails: details, productionStockList: [] })
                    }
                }
                if (resList.length > 0 || this.state.isEditing === true) {
                    this.setState({ validationTextForStock: '' })
                    if (this.state.isEditing === true) {
                        this.setState({ productionStockList: [] })
                    } else {
                        this.setState({ productionStockList: resList })
                    }
                } else {
                    this.setState({ productionStockList: [], validationTextForStock: `Sorry, No Stock available for ${this.state.itemDetails.itemName ? this.state.itemDetails.itemName : 'this product'}.` })
                }
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    }

    selectQtyFromStock = (item) => {
        let details = this.state.itemDetails
        details.batchNo = item.batchNo
        details.mfgDate = moment(item.mfgDate).format("yyyy-MM-DD")
        details.expDate = moment(item.expDate).format("yyyy-MM-DD")
        details.mrp = item.mrp
        // details.qty = item.quantity
        // details.stockTotalqty = item.quantity
        details.batchClearingEntryId = item.batchClearingEntryId
        details.stockId = item._id
        this.setState({ itemDetails: details }, () => {
            this.setState({ productionStockList: [] })
        })
    }

    addItemToItemArray = () => {
        let isValidAllFields = this.isValidAllFields();
        if (isValidAllFields) {
            let itemListing = [...this.state.itemListing];
            let details = { ...this.state.itemDetails }
            if (this.state.index >= 0 && this.state.index !== null && this.state.index !== undefined) {
                itemListing[this.state.index] = details
            } else {
                itemListing.push(details);
            }
            this.setState({ itemListing: itemListing, setItemDetailsModel: false }, () => {
                this.showHSNCodes()
            })
        }
    }

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.itemDetails,
            this.state.validationRules,
            this.state.validState
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    };

    isValidAllFieldsForpartyDetails = () => {
        const newValidState = isValidForm(
            this.state.salesReturnDetails,
            this.state.validationRulesForPartyDetails,
            this.state.validStateForPartyDetails
        );
        this.setState({ validStateForPartyDetails: newValidState });
        return newValidState.isValid;
    };

    showHSNCodes = () => {
        const { itemListing, hsnCodeList } = this.state;

        const hsnCodeSummary = itemListing.reduce((acc, item) => {
            if (!acc[item.hsnCodeId]) {
                acc[item.hsnCodeId] = { hsnCodeId: item.hsnCodeId, taxableAmount: 0 };
            }
            acc[item.hsnCodeId].taxableAmount += item.taxableAmount;
            return acc;
        }, {});

        const summarizedList = Object.values(hsnCodeSummary);

        const hsnCodeListForTable = summarizedList.map(summary => {
            const hsnDetails = hsnCodeList.find(hsn => hsn.value === summary.hsnCodeId) || {};

            const sgstAmount = (summary.taxableAmount * (hsnDetails.sgstRate / 100 || 0)).toFixed(2);
            const cgstAmount = (summary.taxableAmount * (hsnDetails.cgstRate / 100 || 0)).toFixed(2);
            const igstAmount = (summary.taxableAmount * (hsnDetails.igstRate / 100 || 0)).toFixed(2);
            const utgstAmount = (summary.taxableAmount * (hsnDetails.utgstRate / 100 || 0)).toFixed(2);
            const totalAmount = summary.taxableAmount + sgstAmount + cgstAmount + igstAmount + utgstAmount;

            return {
                ...hsnDetails,
                ...summary,
                sgstAmount,
                cgstAmount,
                igstAmount,
                utgstAmount,
                totalAmount
            };
        });
        this.setState({ hsnCodeListForTable }, () => {
            this.calculateGrandTotal()
        });
    }

    calculateGrandTotal = () => {
        let list = this.state.hsnCodeListForTable

        const totals = list.reduce(
            (acc, item) => {
                acc.sgstAmount += Number(item.sgstAmount) || 0;
                acc.cgstAmount += Number(item.cgstAmount) || 0;
                acc.igstAmount += Number(item.igstAmount) || 0;
                acc.utgstAmount += Number(item.utgstAmount) || 0;
                acc.taxableAmount += Number(item.taxableAmount) || 0;
                return acc;
            },
            { sgstAmount: 0, cgstAmount: 0, igstAmount: 0, utgstAmount: 0, taxableAmount: 0 }
        );

        let details = this.state.salesReturnDetails
        details.subTotal = Number(totals.taxableAmount).toFixed(2)
        details.sgst = Number(totals.sgstAmount).toFixed(2)
        details.cgst = Number(totals.cgstAmount).toFixed(2)
        details.crDrNote = 0
        details.grandTotal = (Number(details.subTotal) + Number(details.sgst) + Number(details.cgst)).toFixed(2)
        details.grandTotal = Number(details.grandTotal) + (Number(details.other) || 0)
        details.round = (details.grandTotal % 1).toFixed(2);
        details.grandTotal = Math.floor(details.grandTotal).toFixed(2);

        this.setState({ salesReturnDetails: details })
    }

    editItemDetails = (index) => {
        let list = this.state.itemListing
        let itemDetails = this.state.itemDetails
        let item = list[index];
        itemDetails.itemId = item.itemId
        itemDetails.itemName = item.itemName
        itemDetails.packing = item.packing
        itemDetails.batchNo = item.batchNo
        itemDetails.mfgDate = moment(item.mfgDate).format('yyyy-MM-DD')
        itemDetails.expDate = moment(item.expDate).format('yyyy-MM-DD')
        itemDetails.mrp = item.mrp
        itemDetails.qty = item.qty
        itemDetails.free = item.free
        itemDetails.rate = item.rate
        itemDetails.amount = item.amount
        itemDetails.discRate = item.discRate
        itemDetails.discAmount = item.discAmount
        itemDetails.taxableAmount = item.taxableAmount
        itemDetails.hsnCodeId = item.hsnCodeId
        itemDetails.hsnCodeName = item.hsnCodeName
        itemDetails.sgst = item.sgst
        itemDetails.cgst = item.cgst
        itemDetails.igst = item.igst
        itemDetails.ugst = item.ugst
        // Carry over the fields that link this row to its stock batch and the
        // remaining item fields. Without these, editing a row wiped stockId /
        // batchClearingEntryId and caused the stock update to crash on Save.
        itemDetails.stockUpgrade = item.stockUpgrade
        itemDetails.invoiceNo = item.invoiceNo
        itemDetails.invoiceDate = item.invoiceDate ? moment(item.invoiceDate).format('yyyy-MM-DD') : ''
        itemDetails.returnType = item.returnType
        itemDetails.other = item.other
        itemDetails.sgstRate = item.sgstRate
        itemDetails.cgstRate = item.cgstRate
        itemDetails.igstRate = item.igstRate
        itemDetails.ugstRate = item.ugstRate
        itemDetails.batchClearingEntryId = item.batchClearingEntryId
        itemDetails.stockId = item.stockId
        this.setState({ itemDetails: itemDetails, index: index }, () => {
            this.setState({ setItemDetailsModel: true, isEditing: true })
        })
    }

    deleteSalesGoodsReturnItemById = (item) => {
        let request = {
            stockId: item.stockId,
            batchClearingEntryId: item.batchClearingEntryId,
            gstInvoiceBatchId: item._id,
            salesGoodsReturnId: item.salesGoodsReturnId,
            qty: item.qty,
            free: item.free
        }
        this.despatchServices.deleteSalesGoodsReturnItemById(request).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                this.getSalesGoodsReturnDetailsById(this.state.salesReturnDetails.salesGoodsReturnId)
                this.showHSNCodes()
                this.SwalServices.Success(response.Message);
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    }

    deleteItemById = (index) => {
        let list = [...this.state.itemListing];
        list.splice(index, 1);
        this.setState({ itemListing: list }, () => {
            this.showHSNCodes()
        });
    }

    getSalesGoodsReturnEntryInvoiceNo = () => {
        this.despatchServices.getSalesGoodsReturnEntryInvoiceNo().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let details = this.state.salesReturnDetails
                details.serialNo = response.responseData.serialNo
                details.salesGoodsReturnId = ''
                details.returnDate = moment(new Date()).format('yyyy-MM-DD')
                this.setState({ salesReturnDetails: details }, () => {
                    this.closeGridView()
                })
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    }

    addEditSalesGoodsReturnEntry = () => {
        let isValidAllFieldsForpartyDetails = this.isValidAllFieldsForpartyDetails()
        if (isValidAllFieldsForpartyDetails) {
            this.setState({ isLoading: "save" }, () => {
                if (this.state.itemListing.length > 0) {
                    let request = {
                        salesReturnDetails: this.state.salesReturnDetails,
                        itemListing: this.state.itemListing
                    }
                    this.despatchServices.addEditSalesGoodsReturnEntry(request).then((response) => {
                        if (response.statusCode === 200 && response.responseData != null) {
                            this.setState({ isLoading: "" }, () => { this.openGridView() })
                            this.SwalServices.Success(response.Message);

                        } else {
                            this.setState({ isLoading: "" })
                            this.SwalServices.Error(response.Message);
                        }
                    });

                } else {
                    this.setState({ isLoading: "" })
                    this.SwalServices.Alert('No records found. Please add an item to proceed.')
                }
            })
        }
    }

    getSalesGoodsReturnDetailsById = (id) => {
        this.despatchServices.getSalesGoodsReturnDetailsById(id).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData
                let details = this.state.salesReturnDetails
                details.salesGoodsReturnId = res.salesReturnDetails._id
                details.serialNo = res.salesReturnDetails.serialNo
                details.returnDate = moment(res.salesReturnDetails.returnDate).format('yyyy-MM-DD')
                details.deliveryChallanNo = res.salesReturnDetails.deliveryChallanNo
                details.dcDate = res.salesReturnDetails.dcDate ? moment(res.salesReturnDetails.dcDate).format('yyyy-MM-DD') : ''
                details.transportId = res.salesReturnDetails.transportId._id
                details.transportName = res.salesReturnDetails.transportName ? res.salesReturnDetails.transportName : ''
                details.partyId = res.salesReturnDetails.partyId._id
                details.lRNo = res.salesReturnDetails.lRNo
                details.subTotal = res.salesReturnDetails.subTotal
                details.lRDate = res.salesReturnDetails.lRDate ? moment(res.salesReturnDetails.lRDate).format('yyyy-MM-DD') : ""
                details.sgst = res.salesReturnDetails.sgst
                details.cgst = res.salesReturnDetails.cgst
                details.other = res.salesReturnDetails.other
                details.round = res.salesReturnDetails.round
                details.grandTotal = (res.salesReturnDetails.grandTotal && Number(res.salesReturnDetails.grandTotal) > 0) ? res.salesReturnDetails.grandTotal : 0

                let list = res.itemListing
                list.map(item => {
                    item.isFromDB = true
                    return item
                })
                this.setState({ salesReturnDetails: details, itemListing: list }, () => {
                    this.showHSNCodes()
                    this.setState({ isGridView: false })
                })
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    }

    setOpenModel = () => {
        this.setState({ setItemDetailsModel: !this.state.setItemDetailsModel })
    }

    deleteSalesGoodsReturnById = (id) => {
        this.SwalServices.Confirm(
            "",
            ``,
            CommonSuccessMessages.Yes_Text,
            CommonSuccessMessages.No_Text,
            `Are you sure you want to delete this invoice?`
        ).then((response) => {
            if (response === true) {
                this.despatchServices.deleteSalesGoodsReturnById(id).then((response) => {
                    if (response.statusCode === 200 && response.responseData != null) {
                        this.getAllSalesGoodsReturnEntry()
                        this.SwalServices.Success(response.Message);
                    } else {
                        this.SwalServices.Error(response.Message);
                    }
                });
            }
        });
    }

    render() {
        return (
            <div className='SalesGoodsReturnEntry-page'>
                {/* First Page  */}
                {this.state.isGridView === true ? (
                    <>
                        {/* 1. Item Search  */}
                        <div className="item-search">
                            <div className="item-grp flex gap-2.5 mb-2.5 w-[60%]">
                                <div className="search-grp w-[60%]">
                                    <label>Party Name</label>
                                    <input
                                        type="text"
                                        id="partyName"
                                        name="partyName"
                                        className="inputFocus"
                                        autocomplete="off"
                                        value={this.state.filterDetails.partyName}
                                        onChange={(event) =>
                                            this.handleChange(event, "partyName", "filterDetails")
                                        }
                                    />
                                </div>

                                <div className="search-grp w-[40%]">
                                    <label>Arranged By</label>
                                    <select
                                        name="arrangedBy"
                                        className="w-full"
                                        value={this.state.filterDetails.arrangedBy && this.state.filterDetails.arrangedBy !== 'Select' && this.state.arrangedByList.find(
                                            (party) => party.value === this.state.filterDetails.arrangedBy
                                        ).value}
                                        onChange={(event) =>
                                            this.handleDropDownChange(
                                                event,
                                                "arrangedBy",
                                                "filterDetails"
                                            )
                                        }
                                    >
                                        <option>Select</option>
                                        {this.state.arrangedByList.map((x, key) => (
                                            <option key={key} value={x.value}>
                                                {x.arrangedBy}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                            </div>
                            <button className="add-btn" onClick={() => this.getSalesGoodsReturnEntryInvoiceNo()}>
                                Generate Invoice
                            </button>
                        </div>

                        {/* 2. Item tabel  */}
                        <div className="itemList-table">
                            <div className="table-container" style={{ height: "calc(100vh - 180px)" }}>
                                <table className="itemList">
                                    <thead>
                                        <tr>
                                            <td className='w-[10%]'>Ser. No</td>
                                            <td className='w-[10%]'>Return Date</td>
                                            <td className='w-[15%]'>Party Name</td>
                                            <td className='w-[10%]'>Amount</td>
                                            <td className="w-[10%]" style={{ textAlign: "center" }}>Action</td>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {this.state.salesGoodsReturnList && this.state.salesGoodsReturnList.length > 0 ? (
                                            this.state.salesGoodsReturnList.map((item, key) => (
                                                <tr key={key}>
                                                    <td>{item.serialNo}</td>
                                                    <td>{moment(item.returnDate).format('DD MMM yyyy')}</td>
                                                    <td>{item.partyId.partyName}</td>
                                                    <td>{Number(item.grandTotal).toFixed(2)}</td>
                                                    <td className='!text-center'>
                                                        <button
                                                            className="search-btn"
                                                            onClick={() => this.getSalesGoodsReturnDetailsById(item._id)}
                                                        >
                                                            <FontAwesomeIcon icon={faPen} />
                                                        </button>
                                                        <button
                                                            className="cancel-btn"
                                                            onClick={() => this.deleteSalesGoodsReturnById(item._id)}
                                                        >
                                                            <FontAwesomeIcon icon={faTrash} />
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : this.state.salesGoodsReturnList &&
                                            this.state.salesGoodsReturnList.length === 0
                                            && this.state.tableStatus !== "" ? (
                                            <tr>
                                                <td colSpan={5} style={{ textAlign: "center", fontSize: "16px" }}>
                                                    {this.state.tableStatus}
                                                </td>
                                            </tr>
                                        ) : this.state.salesGoodsReturnList &&
                                            this.state.salesGoodsReturnList.length === 0
                                            && this.state.tableStatus === "" ? null : ""}
                                    </tbody>

                                </table>
                            </div>
                        </div>
                    </>
                ) : null}



                {/* Second Page  */}
                {this.state.isGridView === false ? (
                    <>
                        {/* Item Form - First Section */}
                        <div className="item-form mb-3.5">
                            <div className="item-grp flex gap-2.5 mb-3">
                                <div className="input-grp w-full">
                                    <label>Serial No.</label>
                                    <input
                                        type="text"
                                        id="serialNo"
                                        name="serialNo"
                                        disabled
                                        autocomplete="off"
                                        value={this.state.salesReturnDetails.serialNo}
                                        onChange={(event) =>
                                            this.handleChange(event, "serialNo", "salesReturnDetails")
                                        }
                                    />
                                </div>

                                <div className="input-grp w-full">
                                    <label>Return Date</label>
                                    <input
                                        type="date"
                                        id="returnDate"
                                        name="returnDate"
                                        className="inputFocus"
                                        autocomplete="off"
                                        value={this.state.salesReturnDetails.returnDate}
                                        onChange={(event) =>
                                            this.handleChange(event, "returnDate", "salesReturnDetails")
                                        }
                                    />
                                </div>
                                <div className="input-grp min-w-[35%]">
                                    <label>Party Name</label>
                                    <MultiSelectDropdown
                                        drpIdentity="partyId"
                                        options={this.state.partyDropdownList}
                                        className={` ${this.state.validStateForPartyDetails?.error?.partyId ? "errorInput" : ""}`}
                                        closeMenuOnSelect={true}
                                        hideSelectedOptions={false}
                                        onChange={(selected) =>
                                            this.setFilterParameters(selected, "partyId")
                                        }
                                        allowSelectAll={false}
                                        value={this.state.partyDropdownList.filter(
                                            (party) =>
                                                party.value === this.state.salesReturnDetails.partyId
                                        )}
                                    />
                                    {/* <ValidationText error={this.state.validStateForPartyDetails.error.partyId} /> */}
                                </div>
                                <div className="input-grp w-full">
                                    <label>Transport Name</label>
                                    <MultiSelectDropdown
                                        drpIdentity="transportName"
                                        options={this.state.transportCourierList}
                                        className={` ${this.state.validStateForPartyDetails?.error?.transportId ? "errorInput" : ""}`}
                                        closeMenuOnSelect={true}
                                        hideSelectedOptions={false}
                                        onChange={(selected) =>
                                            this.setFilterParameters(selected, "transportName")
                                        }
                                        allowSelectAll={false}
                                        value={this.state.transportCourierList.filter(
                                            (transport) =>
                                                transport.value === this.state.salesReturnDetails.transportId
                                        )}
                                    />
                                    {/* <ValidationText error={this.state.validStateForPartyDetails.error.transportId} /> */}
                                </div>


                            </div>

                            <div className="item-grp flex gap-2.5 mb-3">

                                <div className="input-grp w-full">
                                    <label>Delivery Challan No</label>
                                    <input
                                        type="text"
                                        id="deliveryChallanNo"
                                        name="deliveryChallanNo"
                                        className="inputFocus"
                                        autocomplete="off"
                                        value={this.state.salesReturnDetails.deliveryChallanNo}
                                        onChange={(event) =>
                                            this.handleChange(
                                                event,
                                                "deliveryChallanNo",
                                                "salesReturnDetails"
                                            )
                                        }
                                    />
                                </div>

                                <div className="input-grp w-full">
                                    <label>D. C. Date</label>
                                    <input
                                        type="date"
                                        id="dcDate"
                                        name="dcDate"
                                        className="inputFocus"
                                        autocomplete="off"
                                        value={this.state.salesReturnDetails.dcDate}
                                        onChange={(event) =>
                                            this.handleChange(event, "dcDate", "salesReturnDetails")
                                        }
                                    />
                                </div>
                                <div className="input-grp w-full">
                                    <label>LR No.</label>
                                    <input
                                        type="text"
                                        id="lRNo"
                                        name="lRNo"
                                        className="inputFocus"
                                        autocomplete="off"
                                        value={this.state.salesReturnDetails.lRNo}
                                        onChange={(event) =>
                                            this.handleChange(event, "lRNo", "salesReturnDetails")
                                        }
                                    />
                                </div>

                                <div className="input-grp w-full">
                                    <label>LR Date</label>
                                    <input
                                        type="date"
                                        id="lRDate"
                                        name="lRDate"
                                        className="inputFocus"
                                        autocomplete="off"
                                        value={this.state.salesReturnDetails.lRDate}
                                        onChange={(event) =>
                                            this.handleChange(event, "lRDate", "salesReturnDetails")
                                        }
                                    />

                                </div>
                            </div>
                        </div>

                        {/* Item Table - Second Section  */}
                        <div className="itemList-table ">
                            <div className="table-container h-[30vh] max-h-[30vh]"
                            >
                                <table className="itemList ">
                                    <thead>
                                        <tr>
                                            <td className='w-[2%]'>Sr.</td>
                                            <td className='w-[17%]'>Item Name</td>
                                            <td className='w-[6%]'>Packing</td>
                                            <td className='w-[8%]'>Batch No</td>
                                            <td className='w-[9%]'>Mfg. Date</td>
                                            <td className='w-[9%]'>Exp. Date</td>
                                            <td className='w-[5%]'>Qty.</td>
                                            <td className='w-[5%]'>Free</td>
                                            <td className='w-[5%]'>Rate</td>
                                            <td className='w-[5%]'>Other</td>
                                            <td className='w-[10%]'>Taxable Amount</td>
                                            <td className='w-[8%]'>HSN Code</td>
                                            <td className='w-[7%]' style={{ textAlign: "center" }}>Action</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.itemListing && this.state.itemListing.length > 0
                                            ? this.state.itemListing.map((item, key) => (

                                                <tr key={key}>
                                                    <td>{key + 1}</td>
                                                    <td>{item.itemName}</td>
                                                    <td>{item.packing}</td>
                                                    <td>{item.batchNo}</td>
                                                    <td>{moment(item.expDate).format('MM-yyyy')}</td>
                                                    <td>{moment(item.mfgDate).format('MM-yyyy')}</td>
                                                    <td>{item.qty}</td>
                                                    <td>{item.free}</td>
                                                    <td>{Number(item.rate).toFixed(2)}</td>
                                                    <td>{item.other}</td>
                                                    <td>{Number(item.taxableAmount).toFixed(2)}</td>
                                                    <td>{item.hsnCodeName}</td>
                                                    <td className='!text-center'>

                                                        <button
                                                            className="search-btn"
                                                            onClick={() => this.editItemDetails(key)}
                                                        >
                                                            <FontAwesomeIcon icon={faPen} />
                                                        </button>
                                                        {item.isFromDB ?
                                                            <button
                                                                className="cancel-btn"
                                                                onClick={() => this.deleteSalesGoodsReturnItemById(item)}
                                                            >
                                                                <FontAwesomeIcon icon={faTrash} />
                                                            </button>
                                                            :
                                                            <button
                                                                className="cancel-btn"
                                                                onClick={() => this.deleteItemById(key)}
                                                            >
                                                                <FontAwesomeIcon icon={faTrash} />
                                                            </button>

                                                        }
                                                    </td>
                                                </tr>
                                            ))
                                            : null}
                                    </tbody>
                                </table>
                            </div>
                            <button
                                disabled={this.state.isHideAddItem}
                                className="add-btn mt-2.5 mb-4"
                                onClick={() => this.openPopUpForAddingItem()}
                            >
                                Add Item
                            </button>

                            {/* ModalBasic  */}
                            <ModalBasic
                                id="adding-item-popUp"
                                modalOpen={this.state.setItemDetailsModel}
                                setModalOpen={this.setOpenModel.bind(this)}
                                title="Item Details"
                                noCloseIcon={true}
                            >
                                <div className="item-form">
                                    <div className="form-table">
                                        {this.state.productionStockList && this.state.productionStockList.length > 0
                                            ?
                                            <div className="table-container mb-3.5 h-[25vh]">
                                                <table className="itemList  ">
                                                    <thead>
                                                        <tr>
                                                            <td className='w-[20%]'>Batch No</td>
                                                            <td className='w-[20%]'>Exp Dt.</td>
                                                            <td className='w-[20%]'>M.R.P.</td>
                                                            <td className='w-[20%]'>Stock</td>
                                                            <td className='w-[20%]'>HSN Code</td>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.productionStockList.map((item, key) => (
                                                            <tr key={key} className='hover:bg-blue-100 cursor-pointer' onClick={() => this.selectQtyFromStock(item)}>
                                                                <td>{item.batchNo}</td>
                                                                <td>{moment(item.expDate).format("DD MMM yyyy")}</td>
                                                                <td>{item.mrp}</td>
                                                                <td>{item.quantity}</td>
                                                                <td>{item.HSNCode}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                            : this.state.validationTextForStock ?
                                                <p
                                                    className=' mb-3 w-fit p-2 rounded-[8px]'
                                                    style={{
                                                        color: "brown",
                                                        fontSize: "13px",
                                                        border: "1px solid #a52a2a57",
                                                        outline: " 2px solid rgb(165 42 42 / 10%)",
                                                    }} >
                                                    {this.state.validationTextForStock}</p>
                                                : null}

                                        <div className="item-grp !flex !gap-2.5">
                                            <div className="input-grp w-[30%]">
                                                <label>Item Name</label>
                                                <MultiSelectDropdown
                                                    drpIdentity="itemId"
                                                    options={this.state.companyItemList}
                                                    closeMenuOnSelect={true}
                                                    className={` ${this.state.validState?.error?.itemId ? "errorInput" : ""}`}
                                                    hideSelectedOptions={false}
                                                    onChange={(selected) =>
                                                        this.setFilterParametersForItemTable(
                                                            selected,
                                                            "itemId"
                                                        )
                                                    }
                                                    allowSelectAll={false}
                                                    value={this.state.companyItemList.filter(
                                                        (party) => party.value === this.state.itemDetails.itemId
                                                    )}
                                                />
                                                {/* <ValidationText error={this.state.validState.error.itemId} /> */}
                                            </div>
                                            <div className="input-grp w-[15%]">
                                                <label>Packing</label>
                                                <input
                                                    type="text"
                                                    id="packing"
                                                    name="packing"
                                                    disabled
                                                    autoComplete='off'
                                                    value={this.state.itemDetails.packing}
                                                    onChange={(event) =>
                                                        this.handleChangeForItemTable(event, "packing")
                                                    }
                                                />
                                            </div>
                                            <div className="input-grp w-[15%]">
                                                <label>Batch No</label>
                                                <input
                                                    type="text"
                                                    id="batchNo"
                                                    name="batchNo"
                                                    disabled
                                                    autoComplete='off'
                                                    value={this.state.itemDetails.batchNo}
                                                    onChange={(event) =>
                                                        this.handleChangeForItemTable(event, "batchNo")
                                                    }
                                                />
                                            </div>
                                            <div className="input-grp w-[20%]">
                                                <label>Mfg Date</label>
                                                <input
                                                    type="date"
                                                    id="mfgDate"
                                                    name="mfgDate"
                                                    disabled
                                                    autoComplete='off'
                                                    value={this.state.itemDetails.mfgDate}
                                                    onChange={(event) =>
                                                        this.handleChangeForItemTable(event, "mfgDate")
                                                    }
                                                />
                                            </div>
                                            <div className="input-grp w-[20%]">
                                                <label>Exp. Date</label>
                                                <input
                                                    type="date"
                                                    id="expDate"
                                                    name="expDate"
                                                    disabled
                                                    autoComplete='off'
                                                    value={this.state.itemDetails.expDate}
                                                    onChange={(event) =>
                                                        this.handleChangeForItemTable(event, "expDate")
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div className="item-grp !flex !gap-2.5 mt-3">
                                            <div className="input-grp w-full">
                                                <label>Stock Upgrade</label>
                                                <select
                                                    name="stockUpgrade"
                                                    className={` ${this.state.validState?.error?.stockUpgrade ? "errorInput" : ""}`}
                                                    value={this.state.itemDetails.stockUpgrade && this.state.itemDetails.stockUpgrade !== 'Select' && this.state.stockUpgradeList.find(
                                                        (party) => party.value === this.state.itemDetails.stockUpgrade
                                                    ).value}
                                                    onChange={(selected) =>
                                                        this.handleDropDownChange(
                                                            selected,
                                                            "stockUpgrade",
                                                            "itemDetails"
                                                        )
                                                    }
                                                >
                                                    <option>Select</option>
                                                    {this.state.stockUpgradeList.map((x, key) => (
                                                        <option key={key} value={x.value}>
                                                            {x.stockUpgrade}
                                                        </option>
                                                    ))}
                                                </select>
                                                {/* <ValidationText error={this.state.validState.error.stockUpgrade} /> */}
                                            </div>
                                            <div className="input-grp w-full">
                                                <label>SI. Invoice No.</label>
                                                <input
                                                    type="text"
                                                    id="invoiceNo"
                                                    name="invoiceNo"
                                                    autoComplete='off'
                                                    value={this.state.itemDetails.invoiceNo}
                                                    onChange={(event) =>
                                                        this.handleChangeForItemTable(event, "invoiceNo")
                                                    }
                                                    className="inputFocus"
                                                />
                                            </div>

                                            <div className="input-grp w-full">
                                                <label>SI. Invoice Date</label>
                                                <input
                                                    type="date"
                                                    id="invoiceDate"
                                                    name="invoiceDate"
                                                    autoComplete='off'
                                                    value={this.state.itemDetails.invoiceDate}
                                                    onChange={(event) =>
                                                        this.handleChangeForItemTable(event, "invoiceDate")
                                                    }
                                                    className="inputFocus"
                                                />
                                            </div>
                                            <div className="input-grp w-full">
                                                <label>Return Type</label>
                                                <select
                                                    name="returnType"
                                                    className={` ${this.state.validState?.error?.returnType ? "errorInput" : ""}`}
                                                    value={this.state.itemDetails.returnType && this.state.itemDetails.returnType !== 'Select' && this.state.returnTypeList.find(
                                                        (party) => party.value === this.state.itemDetails.returnType
                                                    ).value}
                                                    onChange={(selected) =>
                                                        this.handleDropDownChange(
                                                            selected,
                                                            "returnType",
                                                            "itemDetails"
                                                        )
                                                    }
                                                >
                                                    <option>Select</option>
                                                    {this.state.returnTypeList.map((x, key) => (
                                                        <option key={key} value={x.value}>
                                                            {x.returnType}
                                                        </option>
                                                    ))}
                                                </select>
                                                {/* <ValidationText error={this.state.validState.error.returnType} /> */}
                                            </div>
                                        </div>

                                        <div className="item-grp !flex !gap-2.5 mt-3">
                                            <div className="input-grp w-full">
                                                <label>MRP</label>
                                                <input
                                                    type="number"
                                                    id="mrp"
                                                    name="mrp"
                                                    autoComplete='off'
                                                    value={this.state.itemDetails.mrp}
                                                    onChange={(event) =>
                                                        this.handleChangeForItemTable(event, "mrp")
                                                    }
                                                    className="inputFocus"
                                                />
                                            </div>
                                            <div className="input-grp w-full">
                                                <label>Quantity</label>
                                                <input
                                                    type="number"
                                                    id="qty"
                                                    name="qty"
                                                    autoComplete='off'
                                                    className={`inputFocus ${this.state.validState?.error?.itemId ? "errorInput" : ""}`}
                                                    value={this.state.itemDetails.qty}
                                                    onChange={(event) =>
                                                        this.handleChangeForItemTable(event, "qty")
                                                    }
                                                    disabled={this.state.itemDetails.batchClearingEntryId === null ? true : false}
                                                />
                                                {/* <ValidationText error={this.state.validState.error.qty} /> */}
                                            </div>
                                            <div className="input-grp w-full">
                                                <label>Free</label>
                                                <input
                                                    type="number"
                                                    id="free"
                                                    name="free"
                                                    autoComplete='off'
                                                    className="inputFocus"
                                                    value={this.state.itemDetails.free}
                                                    onChange={(event) =>
                                                        this.handleChangeForItemTable(event, "free")
                                                    }
                                                    disabled={this.state.itemDetails.batchClearingEntryId === null ? true : false}
                                                />
                                            </div>
                                            <div className="input-grp w-full">
                                                <label>Rate</label>
                                                <input
                                                    type="number"
                                                    id="rate"
                                                    name="rate"
                                                    autoComplete='off'
                                                    className={`inputFocus ${this.state.validState?.error?.rate ? "errorInput" : ""}`}
                                                    value={this.state.itemDetails.rate}
                                                    onChange={(event) =>
                                                        this.handleChangeForItemTable(event, "rate")
                                                    }
                                                    disabled={this.state.itemDetails.batchClearingEntryId === null ? true : false}
                                                />
                                                {/* <ValidationText error={this.state.validState.error.rate} /> */}
                                            </div>
                                            <div className="input-grp w-full">
                                                <label>Amount</label>
                                                <input
                                                    type="number"
                                                    id="amount"
                                                    name="amount"
                                                    disabled
                                                    autoComplete='off'
                                                    className='inputFocus'
                                                    value={this.state.itemDetails.amount}
                                                    onChange={(event) =>
                                                        this.handleChangeForItemTable(event, "amount")
                                                    }
                                                />
                                            </div>

                                        </div>
                                        <div className="item-grp !flex !gap-2.5 mt-3">
                                            <div className="input-grp min-w-[15%]">
                                                <label>Other (+)</label>
                                                <input
                                                    type="number"
                                                    id="other"
                                                    name="other"
                                                    autoComplete='off'
                                                    className='inputFocus'
                                                    value={this.state.itemDetails.other}
                                                    onChange={(event) =>
                                                        this.handleChangeForItemTable(event, "other")
                                                    }
                                                />
                                            </div>

                                            <div className="input-grp min-w-[15%]">
                                                <label>Taxable Amount</label>
                                                <input
                                                    type="number"
                                                    id="taxableAmount"
                                                    name="taxableAmount"
                                                    disabled
                                                    autoComplete='off'
                                                    className='inputFocus'
                                                    value={this.state.itemDetails.taxableAmount}
                                                    onChange={(event) =>
                                                        this.handleChangeForItemTable(event, "taxableAmount")
                                                    }
                                                />
                                            </div>
                                            <div className="input-grp w-full">
                                                <label>HSN Code</label>
                                                <MultiSelectDropdown
                                                    drpIdentity="hsnCodeId"
                                                    options={this.state.hsnCodeList}
                                                    closeMenuOnSelect={true}
                                                    className={` ${this.state.validState?.error?.hsnCodeId ? "errorInput" : ""}`}
                                                    hideSelectedOptions={false}
                                                    onChange={(selected) =>
                                                        this.setFilterParametersForItemTable(
                                                            selected,
                                                            "hsnCodeId",
                                                        )
                                                    }
                                                    allowSelectAll={false}
                                                    value={this.state.hsnCodeList.filter(
                                                        (party) => party.value === this.state.itemDetails.hsnCodeId
                                                    )}
                                                />
                                                {/* <ValidationText error={this.state.validState.error.hsnCodeId} /> */}
                                            </div>
                                            <div className="input-grp !min-w-[10%]">
                                                <label>SGST [%]</label>
                                                <input className="inputFocus"
                                                    type="number"
                                                    id="sgstRate"
                                                    name="sgstRate"
                                                    disabled
                                                    autoComplete='off'
                                                    value={this.state.itemDetails.sgstRate}
                                                    onChange={(event) =>
                                                        this.handleChangeForItemTable(event, "sgstRate")
                                                    }
                                                />
                                            </div>
                                            <div className="input-grp !min-w-[10%]">
                                                <label>CGST [%]</label>
                                                <input className="inputFocus"
                                                    type="number"
                                                    id="cgstRate"
                                                    name="cgstRate"
                                                    disabled
                                                    autoComplete='off'
                                                    value={this.state.itemDetails.cgstRate}
                                                    onChange={(event) =>
                                                        this.handleChangeForItemTable(event, "cgstRate")
                                                    }
                                                />
                                            </div>
                                            <div className="input-grp !min-w-[10%]">
                                                <label>IGST [%]</label>
                                                <input className="inputFocus"
                                                    type="number"
                                                    id="igstRate"
                                                    name="igstRate"
                                                    disabled
                                                    autoComplete='off'
                                                    value={this.state.itemDetails.igstRate}
                                                    onChange={(event) =>
                                                        this.handleChangeForItemTable(event, "igstRate")
                                                    }
                                                />
                                            </div>
                                            <div className="input-grp !min-w-[10%]">
                                                <label>UGST [%]</label>
                                                <input className="inputFocus"
                                                    type="number"
                                                    id="ugstRate"
                                                    name="ugstRate"
                                                    disabled
                                                    autoComplete='off'
                                                    value={this.state.itemDetails.ugstRate}
                                                    onChange={(event) =>
                                                        this.handleChangeForItemTable(event, "ugstRate")
                                                    }
                                                />
                                            </div>


                                        </div>
                                        <div className="btn-grp flex gap-2.5 mt-5">
                                            {this.state.isEditing ?
                                                <button
                                                    className="add-btn"
                                                    onClick={() => this.addItemToItemArray()}
                                                >
                                                    Save
                                                </button> :
                                                <button
                                                    className="add-btn"
                                                    onClick={() => this.addItemToItemArray()}
                                                >
                                                    Add
                                                </button>
                                            }

                                            <button
                                                className="cancel-btn"
                                                onClick={() => this.closePopUp()}
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </ModalBasic>
                        </div>

                        {/* Hsn Table & Summary - third Section  */}
                        <div className="flex  gap-3 mb-4">
                            {/* Hsn Table  */}
                            <div className="itemList-table w-full">
                                <div className="table-container max-h-[303px] h-full">
                                    <table className="itemList">
                                        <thead>
                                            <tr>
                                                <td className='w-[4%]'>Sr.</td>
                                                <td className='w-[16%]'>HSN Code</td>
                                                <td className='w-[16%]'>Amount</td>
                                                <td className='w-[16%]'>SGST Rate</td>
                                                <td className='w-[16%]'>SGST Amount</td>
                                                <td className='w-[16%]'>CGST Rate</td>
                                                <td className='w-[16%]'>CGST Amount</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.hsnCodeListForTable && this.state.hsnCodeListForTable.length > 0
                                                ? this.state.hsnCodeListForTable.map((item, key) => (

                                                    <tr key={key}>
                                                        <td>{key + 1}</td>
                                                        <td>{item.label}</td>
                                                        <td>{item.taxableAmount}</td>
                                                        <td>{item.sgstRate}%</td>
                                                        <td>{item.sgstAmount}</td>
                                                        <td>{item.cgstRate}%</td>
                                                        <td>{item.cgstAmount}</td>
                                                    </tr>
                                                ))
                                                : null}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            {/* Summary  */}
                            <div className="item-sections rounded-[10px] min-w-[260px] max-w-[300px]   p-3  " style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px', backgroundColor: "#f5f5f5" }}>
                                <p className='text-center font-semibold'>Summary</p>
                                <div className="search-grp flex gap-2">
                                    <div className="w-[40%] flex items-center text-[14px] font-medium text-[#585858] pt-[8px] ">
                                        SUB Total
                                    </div>
                                    <input
                                        className="inputFocus w-[60%] !bg-transparent !border-t-0 !border-l-0 !border-r-0 !rounded-none !table-cell !align-bottom !pb-[0px] !ml-[1px] !mr-[1px]"
                                        type="number"
                                        id="subTotal"
                                        name="subTotal"
                                        autocomplete="off"
                                        disabled
                                        value={this.state.salesReturnDetails.subTotal}
                                        onChange={(event) =>
                                            this.handleChange(event, "subTotal", "salesReturnDetails")
                                        }
                                    />
                                </div>



                                <div className="search-grp flex gap-2">
                                    <div className="w-[40%] flex items-center text-[14px] font-medium text-[#585858] pt-[8px] ">
                                        SGST
                                    </div>
                                    <input
                                        className="inputFocus w-[60%] !bg-transparent !border-t-0 !border-l-0 !border-r-0 !rounded-none !table-cell !align-bottom !pb-[0px] !ml-[1px] !mr-[1px]"
                                        type="number"
                                        id="sgst"
                                        name="sgst"
                                        autocomplete="off"
                                        disabled
                                        value={this.state.salesReturnDetails.sgst}
                                        onChange={(event) =>
                                            this.handleChange(event, "sgst", "salesReturnDetails")
                                        }
                                    />
                                </div>

                                <div className="search-grp flex gap-2">
                                    <div className="w-[40%] flex items-center text-[14px] font-medium text-[#585858] pt-[8px] ">
                                        CGST
                                    </div>
                                    <input
                                        className="inputFocus w-[60%] !bg-transparent !border-t-0 !border-l-0 !border-r-0 !rounded-none !table-cell !align-bottom !pb-[0px] !ml-[1px] !mr-[1px]"
                                        type="number"
                                        id="cgst"
                                        name="cgst"
                                        autocomplete="off"
                                        disabled
                                        value={this.state.salesReturnDetails.cgst}
                                        onChange={(event) =>
                                            this.handleChange(event, "cgst", "salesReturnDetails")
                                        }
                                    />
                                </div>


                                <div className="search-grp flex gap-2">
                                    <div className="w-[40%] flex items-center text-[14px] font-medium text-[#585858] pt-[8px] ">
                                        Other
                                    </div>
                                    <input
                                        className="inputFocus w-[60%] h-[35px]  mt-[8px]"
                                        type="number"
                                        id="other"
                                        name="other"
                                        autocomplete="off"
                                        value={this.state.salesReturnDetails.other}
                                        onChange={(event) =>
                                            this.handleChange(event, "other", "salesReturnDetails")
                                        }
                                    />
                                </div>

                                <div className="search-grp flex gap-2">
                                    <div className="w-[40%] flex items-center text-[14px] font-medium text-[#585858] pt-[8px] ">
                                        Round off
                                    </div>
                                    <input
                                        className="inputFocus w-[60%] !bg-transparent !border-t-0 !border-l-0 !border-r-0 !rounded-none !table-cell !align-bottom !pb-[0px] !ml-[1px] !mr-[1px]"
                                        type="number"
                                        id="round"
                                        name="round"
                                        autocomplete="off"
                                        value={this.state.salesReturnDetails.round}
                                        onChange={(event) =>
                                            this.handleChange(event, "round", "salesReturnDetails")
                                        }
                                        disabled={true}
                                    />
                                </div>

                                <div className="search-grp flex gap-2.5 mt-[12px]">
                                    <div className="w-[35%]  flex items-center text-[14px] font-medium text-[#585858]">
                                        Grand Total
                                    </div>
                                    <input
                                        className="inputFocus w-[65%] !h-[40px]"
                                        type="number"
                                        id="grandTotal"
                                        name="grandTotal"
                                        autocomplete="off"
                                        disabled
                                        value={this.state.salesReturnDetails.grandTotal}
                                        onChange={(event) =>
                                            this.handleChange(event, "grandTotal", "salesReturnDetails")
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div className="btn-grp flex gap-2.5 mt-4">

                            {/* Buttons - Last section  */}
                            <button
                                className="add-btn"
                                onClick={() => this.addEditSalesGoodsReturnEntry()}
                                disabled={this.state.isLoading}
                            >
                                {this.state.isLoading === "save" ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Save"}
                            </button>
                            {/* {this.state.salesReturnDetails.gstInvoiceFinishGoodsId !== '' ? */}
                            {/* <button
                                className="print-btn"
                                onClick={() => this.generateGSTInvoiceForFinishGoodsById()}
                                disabled={this.state.isLoading}
                            >
                                {this.state.isLoading === "print" ? <FontAwesomeIcon icon={faSpinner} className="loader" /> : "Print"}
                            </button> */}
                            {/* : null} */}

                            <button
                                className="cancel-btn"
                                onClick={() => this.openGridView()}
                                disabled={this.state.isLoading}
                            >
                                Cancel
                            </button>
                        </div>
                    </>
                ) : null
                }

            </div>

        );
    }
}

export default SalesGoodsReturnEntry;